
import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles, UserPen, Clapperboard, PrinterCheck , WandSparkles ,MicVocal, CalendarClock } from "lucide-react";
import { Link } from "react-router-dom";
import { someUtil } from "../utils";
import { createPageUrl } from "../utils";
const categories = [
  {
    id: 1,
    key: "تسويق",
    title: "التسويـق الـرقمـي",
description: `• إدارة حسابات التواصل الاجتماعي
• الحملات الإعلانية المدفوعة
 (Google – Meta – Snapchat – TikTok)
• تحسين محركات البحث (SEO)
• المحتوى الإبداعي والتحليل الرقمي`,
   icon: < MicVocal className="w-8 h-8 md:w-10 md:h-10" />, 

    bgColor: "bg-[#ee9805]/10 border border-[#141d3c]/10"
  },
  {
    id: 2,
    key: "تصميم",
    title: "الهوية البصرية والعلامة التجارية",
    description: `• تصميم الشعارات والهويات البصرية
• تطوير العلامات التجارية وإعادة التموضع
• إعداد Brand Manual 
  `,
      icon: < WandSparkles className="w-8 h-8 md:w-10 md:h-10" />, 

    bgColor: "bg-[#19b0c1]/10 border border-[#141d3c]/10"
  },
  {
    id: 3,
    key: "تصوير",
    title: "الإنتاج الإعلامي والتصوير ",
   description: `• تصوير فوتوغرافي تجاري وإعلاني  
• إنتاج فيديوهات إبداعية وموشن جرافيك  
• إدارة جلسات التصوير والإنتاج الميداني`,

     icon: < Clapperboard className="w-8 h-8 md:w-10 md:h-10" />, 

    bgColor: "bg-[#e8e9eb]/10 border border-[#141d3c]/10"
  },
  {
    id: 4,
    key: "طباعه",
    title: "الطباعة والإنتاج المطبعي",
    description: `
• طباعة رقمية وأوفست عالية الجودة  
• تصميم وتنفيذ البروشورات والكروت والهدايا الإعلانية  
• تجهيز مواد المعارض والفعاليات  `,
    icon: < PrinterCheck className="w-8 h-8 md:w-10 md:h-10" />,  
    bgColor: "bg-[#ee9805]/10 border border-[#141d3c]/10"
  },
  {
    id: 5,
    key: "تنظيم فعاليات",
    title: " تنظيم الفعاليات والإيفنتات ",
    description: `
• تنظيم المعارض والمؤتمرات  
• تصميم وتنفيذ الأجنحة والمواقع التفاعلية  
• التغطية الإعلامية للفعاليات  `,
      icon: < CalendarClock className="w-8 h-8 md:w-10 md:h-10" />, 

    bgColor: "bg-[#141d3c]/10 border border-[#141d3c]/10"
  },
  {
    id: 6,
    key: "استشارات",
    title: "الاستشارات التسويقية",    
    description: ` 
• إعداد الاستراتيجيات التسويقية  
• تحليل السوق والمنافسين  
• بناء خطط النمو والتوسع`,
       icon: < UserPen className="w-8 h-8 md:w-10 md:h-10" />,  

    bgColor: "bg-[#19b0c1]/10 border border-[#141d3c]/10"
  }
];

export default function CategoriesSection() {
  const scrollRef = React.useRef(null);
React.useEffect(() => {
  const scrollContainer = scrollRef.current;
  if (!scrollContainer) return;

  let scrollAmount = 0;
  const scrollStep = 1; // سرعة التمرير
  let animationFrameId;

  const autoScroll = () => {
    scrollAmount += scrollStep;
    if (scrollAmount >= scrollContainer.scrollWidth / 2) {
      scrollAmount = 0; // لإعادة التكرار بسلاسة
    }
    scrollContainer.scrollLeft = scrollAmount;
    animationFrameId = requestAnimationFrame(autoScroll);
  };

  autoScroll();

  const handleMouseEnter = () => cancelAnimationFrame(animationFrameId);
  const handleMouseLeave = () => autoScroll();

  scrollContainer.addEventListener('mouseenter', handleMouseEnter);
  scrollContainer.addEventListener('mouseleave', handleMouseLeave);

  return () => {
    cancelAnimationFrame(animationFrameId);
    scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
    scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
  };
}, []);


  return (
<section className=" pt-16 md:pt-20 pb-24 md:pb-32 bg-[#e8e9eb] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 bg-[#141d3c]/10 rounded-full px-4 py-2 mb-6">
            <span className="font-sans text-lg text-[#141d3c] font-medium">ZAN DIGITAL MARKETING</span>
          </div>
          
          <h2 className="font-cairo text-xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-3xl text-[#141d3c]">خدمات متكاملة ترتقي بعلامتك التجارية إلى مستوى جديد</span>
            <br />
            <span className="text-xl text-[#ee9805]">حلول تسويقية وإبداعية شاملة - كل ما تحتاجه لنمو وتوسّع أعمالك في مكان واحد.</span>
          </h2>
          
          <p className="font-mono font-bold text-lg text-[#90909098] max-w-2xl mx-auto">
____________________________________________          </p>
        </motion.div>

        {/* Auto-Scrolling Categories */}
        <div className="relative">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-[#e8e9eb] via-[#e8e9eb] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-[#e8e9eb] via-[#e8e9eb] to-transparent z-10 pointer-events-none" />
          
          {/* Scrollable Container */}
          <div 
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto scrollbar-hide pb-4 cursor-pointer"
            style={{ 
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
          >
            {/* Duplicate categories for seamless loop */}
            {[...categories, ...categories].map((category, index) => (
              <Link 
                key={`${category.id}-${index}`} 
                to={createPageUrl(`Services?category=${category.key}`)} 
                className="flex-shrink-0 w-80 group cursor-pointer"
              >
                <motion.div
                  initial={{ opacity: 0, y: 60, scale: 0.9 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  transition={{ 
                    duration: 0.8, 
                    delay: (index % categories.length) * 0.1,
                    ease: "easeOut"
                  }}
                  viewport={{ once: true }}
                  className="h-full"
                >
                  <div className={`${category.bgColor} rounded-3xl p-6 h-full flex flex-col hover:shadow-xl transition-all duration-500 group-hover:-translate-y-2 min-h-[280px]`}>
                    {/* Icon */}
                    <div className="mb-6 text-[#141d3c] group-hover:text-[#141d3c] transition-colors duration-300">
                      {category.icon}
                    </div>
                    
                    {/* Content */}
                    <h3 className="font-cairo text-xl font-bold text-[#141d3c] mb-4 group-hover:text-[#141d3c] transition-colors duration-300 leading-tight">
                      {category.title}
                    </h3>
                    
                   <p className="font-cairo text-sm text-[#141d3c]/70 leading-relaxed mb-6 flex-grow whitespace-pre-line">
  {category.description}
</p>

                    
                    {/* Read More Button */}
                    <div className="flex items-center gap-2 font-cairo text-sm font-medium text-gray-500 hover:text-[#141d3c] transition-colors duration-300 group mt-auto">
الوصـول للخدمة                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                    </div>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>
        </div>

        {/* Manual Navigation Hint */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-8"
        >
          <p className="font-cairo text-sm text-gray-400">
زان … نصنـع حضـورك، ونبنـي حمـلات تجـذب الانـتـبـاه وتتـرك أثـر لا يُـنـسـى.          </p>
        </motion.div>
      </div>

      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      
      
    </section>
    
  );
}
